var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3516 1.25H3.6484C3.35933 1.25 3.125 1.48433 3.125 1.7734C3.125 3.43918 3.78673 5.03673 4.96461 6.21461L5.7266 6.9766C5.80227 7.05227 5.8401 7.0901 5.86719 7.12644C6.03243 7.34807 6.03243 7.65193 5.86719 7.87356C5.8401 7.9099 5.80227 7.94773 5.7266 8.0234L4.96461 8.78539C3.78673 9.96327 3.125 11.5608 3.125 13.2266C3.125 13.5157 3.35933 13.75 3.6484 13.75H11.3516C11.6407 13.75 11.875 13.5157 11.875 13.2266C11.875 11.5608 11.2133 9.96327 10.0354 8.78539L9.2734 8.0234C9.19773 7.94773 9.1599 7.9099 9.13281 7.87356C8.96757 7.65193 8.96757 7.34807 9.13281 7.12644C9.1599 7.0901 9.19773 7.05227 9.2734 6.9766L10.0354 6.21461C11.2133 5.03673 11.875 3.43918 11.875 1.7734C11.875 1.48433 11.6407 1.25 11.3516 1.25Z",
    stroke: "#444444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.daacf429a549c1349de9c0d6b0349d78.svg";
export { ForwardRef as ReactComponent };